import { render, staticRenderFns } from "./heim-site-card.vue?vue&type=template&id=2c5198e0&scoped=true&"
import script from "./heim-site-card.vue?vue&type=script&lang=js&"
export * from "./heim-site-card.vue?vue&type=script&lang=js&"
import style0 from "./heim-site-card.vue?vue&type=style&index=0&id=2c5198e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5198e0",
  null
  
)

component.options.__file = "heim-site-card.vue"
export default component.exports